import React, { useState } from 'react';
import { storeGetOrDefault, storeSet, DEF_DEALERS } from '../../store';
import '../admin.css';

const empty = () => ({ id: Date.now(), region: '', name: '', address: '', rep: '', phone: '', email: '', altEmail: '', website: '', websiteUrl: '' });

const Toast = ({ msg, type }) => msg ? <div className={`adm-toast adm-toast-${type}`}>{msg}</div> : null;

const DealersAdmin = () => {
  const [items, setItems] = useState(() => storeGetOrDefault('dealers', DEF_DEALERS));
  const [mode, setMode]   = useState(null);
  const [form, setForm]   = useState(empty());
  const [toast, setToast] = useState({ msg: '', type: 'success' });

  const showToast = (msg, type = 'success') => { setToast({ msg, type }); setTimeout(() => setToast({ msg: '', type: 'success' }), 3000); };
  const save      = (list) => { setItems(list); storeSet('dealers', list); };

  const openAdd  = () => { setForm(empty()); setMode('add'); };
  const openEdit = (d) => { setForm({ ...d }); setMode('edit'); };
  const close    = () => setMode(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.region.trim()) return showToast('Name and region are required.', 'error');
    if (mode === 'add') {
      save([...items, { ...form, id: Date.now() }]);
      showToast('Dealer added!');
    } else {
      save(items.map(d => d.id === form.id ? { ...form } : d));
      showToast('Dealer updated!');
    }
    close();
  };

  const del    = (id) => { if (window.confirm('Delete this dealer?')) { save(items.filter(d => d.id !== id)); showToast('Dealer removed.', 'info'); } };
  const toggle  = (id) => { save(items.map(d => d.id === id ? { ...d, disabled: !d.disabled } : d)); };
  const move = (idx, dir) => {
    const list = [...items]; const swap = idx + dir;
    if (swap < 0 || swap >= list.length) return;
    [list[idx], list[swap]] = [list[swap], list[idx]];
    save(list);
  };

  const field = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  return (
    <div className='adm-page'>
      <Toast {...toast} />
      <div className='adm-header'>
        <div>
          <h1 className='adm-title'>Dealers</h1>
          <p className='adm-subtitle'>{items.length} authorized regional dealers</p>
        </div>
        <button className='adm-btn adm-btn-primary' onClick={openAdd}>+ Add Dealer</button>
      </div>

      <div className='adm-table-wrap'>
        <table className='adm-table'>
          <thead>
            <tr>
              <th>#</th><th>Region</th><th>Dealer Name</th><th>Contact</th><th>Email</th><th>Status</th><th>Order</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={8}><div className='adm-empty'><div className='adm-empty-icon'>🏪</div><p>No dealers added.</p></div></td></tr>}
            {items.map((d, idx) => (
              <tr key={d.id} style={{ opacity: d.disabled ? 0.5 : 1 }}>
                <td style={{ color: '#999', fontSize: '.78rem' }}>{idx + 1}</td>
                <td><span className='adm-badge adm-badge-yellow'>{d.region}</span></td>
                <td style={{ fontWeight: 600 }}>{d.name}</td>
                <td style={{ fontSize: '.83rem', color: '#555' }}>{d.phone}</td>
                <td style={{ fontSize: '.83rem' }}><a href={`mailto:${d.email}`} style={{ color: '#2878c4', textDecoration: 'none' }}>{d.email}</a></td>
                <td>
                  <button
                    onClick={() => toggle(d.id)}
                    style={{
                      padding: '4px 12px', borderRadius: 20, border: 'none', cursor: 'pointer',
                      fontWeight: 700, fontSize: '.75rem',
                      background: d.disabled ? '#fee2e2' : '#dcfce7',
                      color: d.disabled ? '#dc2626' : '#16a34a',
                    }}
                    title={d.disabled ? 'Click to enable' : 'Click to disable'}
                  >
                    {d.disabled ? 'Disabled' : 'Enabled'}
                  </button>
                </td>
                <td>
                  <div className='adm-order-col'>
                    <button className='adm-order-btn' onClick={() => move(idx, -1)} disabled={idx === 0}>▲</button>
                    <button className='adm-order-btn' onClick={() => move(idx, 1)}  disabled={idx === items.length - 1}>▼</button>
                  </div>
                </td>
                <td>
                  <div className='adm-actions'>
                    <button className='adm-btn adm-btn-outline adm-btn-sm' onClick={() => openEdit(d)}>Edit</button>
                    <button className='adm-btn adm-btn-danger  adm-btn-sm' onClick={() => del(d.id)}>Delete</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {mode && (
        <div className='adm-modal-overlay' onClick={e => e.target === e.currentTarget && close()}>
          <div className='adm-modal adm-modal-lg'>
            <div className='adm-modal-header'>
              <h2 className='adm-modal-title'>{mode === 'add' ? 'Add Dealer' : 'Edit Dealer'}</h2>
              <button className='adm-close-btn' onClick={close}>✕</button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className='adm-modal-body'>
                <div className='adm-form'>
                  <div className='adm-form-row'>
                    <div className='adm-form-group'>
                      <label className='adm-label adm-label-req'>Region</label>
                      <input className='adm-input' value={form.region} onChange={field('region')} placeholder='Maharashtra & Goa' required />
                    </div>
                    <div className='adm-form-group'>
                      <label className='adm-label adm-label-req'>Dealer Name</label>
                      <input className='adm-input' value={form.name} onChange={field('name')} placeholder='Arham Agencies' required />
                    </div>
                  </div>
                  <div className='adm-form-group'>
                    <label className='adm-label'>Address</label>
                    <textarea className='adm-input adm-textarea' style={{ minHeight: 60 }} value={form.address} onChange={field('address')} />
                  </div>
                  <div className='adm-form-row'>
                    <div className='adm-form-group'>
                      <label className='adm-label'>Representative</label>
                      <input className='adm-input' value={form.rep} onChange={field('rep')} placeholder='Mr. Name, Title' />
                    </div>
                    <div className='adm-form-group'>
                      <label className='adm-label'>Phone</label>
                      <input className='adm-input' value={form.phone} onChange={field('phone')} placeholder='+91 98xxx xxxxx' />
                    </div>
                  </div>
                  <div className='adm-form-row'>
                    <div className='adm-form-group'>
                      <label className='adm-label'>Email</label>
                      <input className='adm-input' type='email' value={form.email} onChange={field('email')} />
                    </div>
                    <div className='adm-form-group'>
                      <label className='adm-label'>Alternate Email</label>
                      <input className='adm-input' type='email' value={form.altEmail} onChange={field('altEmail')} />
                    </div>
                  </div>
                  <div className='adm-form-row'>
                    <div className='adm-form-group'>
                      <label className='adm-label'>Website (display)</label>
                      <input className='adm-input' value={form.website} onChange={field('website')} placeholder='www.example.com' />
                    </div>
                    <div className='adm-form-group'>
                      <label className='adm-label'>Website URL</label>
                      <input className='adm-input' value={form.websiteUrl} onChange={field('websiteUrl')} placeholder='https://www.example.com' />
                    </div>
                  </div>
                </div>
              </div>
              <div className='adm-modal-footer'>
                <button type='button' className='adm-btn adm-btn-ghost' onClick={close}>Cancel</button>
                <button type='submit' className='adm-btn adm-btn-primary'>{mode === 'add' ? 'Add Dealer' : 'Save'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DealersAdmin;
